/* Product pages: tapping the Judge.me star badge scrolls to the reviews.
   Moved out of layout/theme.liquid (still product pages only) so browsers cache it. */
(function () {
  function target() {
    return document.querySelector('.jdgm-rev-widg') ||
      document.querySelector('#judgeme_product_reviews') ||
      document.querySelector('.jdgm-widget.jdgm-review-widget');
  }

  function scrollToReviews() {
    var w = target();
    if (!w) return false;

    var d = w.closest && w.closest('details');
    if (d && !d.open) d.open = true;

    var header = document.querySelector('#shopify-section-header,header,.header');
    var off = header ? Math.ceil(header.getBoundingClientRect().height) : 0;
    var y = w.getBoundingClientRect().top + window.pageYOffset - off - 12;
    window.scrollTo({ top: y, behavior: 'smooth' });
    return true;
  }

  document.addEventListener('click', function (e) {
    var hit = e.target.closest && e.target.closest('.jdgm-prev-badge,.jdgm-prev-badge__stars,.jdgm-prev-badge__text,.jdgm-star');
    if (!hit) return;

    if (scrollToReviews()) {
      e.preventDefault();
      return;
    }

    var obs = new MutationObserver(function () {
      if (scrollToReviews()) obs.disconnect();
    });

    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () {
      obs.disconnect();
    }, 4000);
  }, true);

  if (location.hash && location.hash.indexOf('judgeme_product_reviews') > -1) {
    window.addEventListener('load', function () {
      setTimeout(scrollToReviews, 200);
    });
  }
})();
